export class ContactSupportDto {

    codeSogiphar: string;
    object: string;
    message: string;
    recontactMethode: string;
    recontactInfo: string;

    constructor() {
    }

    public getCodeSogiphar(): string {
        return this.codeSogiphar;
    }

    public setCodeSogiphar(codeSogiphar: string) {
        this.codeSogiphar = codeSogiphar;
        return this;
    }

    public getSupportObject(): string {
        return this.object;
    }

    public setSupportObject(object: string) {
        this.object = object;
        return this;
    }

    public getMessage(): string {
        return this.message;
    }

    public setMessage(message: string) {
        this.message = message;
        return this;
    }

    public getRecontactMethode(): string {
        return this.recontactMethode;
    }

    public setRecontactMethode(recontactMethode: string) {
        this.recontactMethode = recontactMethode;
        return this;
    }

    public getRecontactInfo(): string {
        return this.recontactInfo;
    }

    public setRecontactInfo(recontactInfo: string) {
        this.recontactInfo = recontactInfo;
        return this;
    }


}